module.exports = {"svg":{"$":{"viewBox":"0 0 125 164","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"path":[{"$":{"d":"M115.128,82.154 L7.801,10.32 L7.801,153.988 L115.128,82.154 L115.128,82.154 Z M123.26,79.226 C123.65,79.476 123.997,79.809 124.271,80.218 C125.339,81.814 124.914,83.975 123.318,85.044 L6.479,163.242 C5.884,163.716 5.13,163.999 4.311,163.999 C2.384,163.999 0.821,162.436 0.821,160.51 L0.821,3.798 L0.833,3.798 C0.833,3.131 1.023,2.458 1.422,1.862 C2.49,0.267 4.651,-0.159 6.247,0.908 L123.26,79.226 Z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-play.svg
// module id = 498
// module chunks = 0